import { Family } from "./Family";
import { NocSizes } from "./NocSizes";
import { Observation } from './Observation';
import { UseConditions } from "./UseConditions";

export class Clothes{
    id: number;
    code: string;
    createDate: Date;
    visible: boolean;
    name: string;
    finalName:string;
    temporaryName:string;
    prices: {
        price: number,
        priceDate: Date
    }[];        
    family: Family;
    nocSizes: NocSizes[];
    sex: string;
    pictures: {
        pictureDate: Date,
        picture: string,
        deleted: boolean,
        fileName: string
    }[]
    observations: Observation[] 
    size: string
    description: string
    composition: string
    useConditions: UseConditions[]
}